import {writable} from "svelte/store";
import {todos, eliminar} from '../Api/sedes';

const estadoInicial = {
  cargando: false,
  error: null,
  listado: [],
  listadoIndexado: {},
  ausencias: [],
  actividades: [],
  sedeEliminando: null,
  errorEliminacion: null
};

const store = writable(estadoInicial);

export default {
  subscribe: store.subscribe,
  cargar: () => {
    const timeout = setTimeout(() => store.update(valor => ({...valor, cargando: true})), 100);

    store.update(() => estadoInicial);

    todos()
        .then(listado => store.update(valor => ({
          ...valor,
          listado: listado,
          listadoIndexado: listado.reduce((acc, x) => ({[x.id]: x, ...acc}), {}),
          ausencias: listado.filter(x => x.sede === 'Ausencia'),
          actividades: listado.filter(x => x.sede === 'Actividad'),
          error: false
        })))
        .catch(e => store.update(valor => ({...valor, error: e})))
        .finally(() => {
          clearTimeout(timeout);
          store.update(valor => ({...valor, cargando: false}));
        });
  },
  eliminarSede(sede) {
    store.update(estado => ({
      ...estado,
      sedeEliminando: sede,
      errorEliminacion: null
    }));
  },
  eliminaSedeDeVerdad(sede) {
    eliminar(sede).then(() => {
      store.update(x => ({...x, sedeEliminando: null, errorEliminacion: null}));
      this.cargar();
    }).catch(e => store.update(x => ({...x, errorEliminacion: e.response.data})));
  }
};